var _linearGradient, _path, _radialGradient, _path2, _radialGradient2, _path3, _radialGradient3, _path4, _radialGradient4, _path5, _radialGradient5, _path6, _linearGradient2, _path7, _radialGradient6, _path8, _path9, _radialGradient7, _path10, _path11, _radialGradient8, _path12, _radialGradient9, _path13, _linearGradient3, _path14, _radialGradient10, _path15, _radialGradient11, _path16, _radialGradient12, _path17, _radialGradient13, _path18, _radialGradient14, _path19, _radialGradient15, _path20, _defs, _mask, _radialGradient16, _path21, _radialGradient17, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 16 16",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -2.313,
    x2: -2.313,
    y1: 19.862,
    y2: 20.738,
    gradientTransform: "matrix(16 0 0 -16 45 333)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f28a2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fde86f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M16,8c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8C12.4,0,16,3.6,16,8z",
    clipRule: "evenodd"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: -2.313,
    cy: 20.313,
    r: 0.5,
    gradientTransform: "matrix(16 0 0 -16 45 333)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f28a2d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f08423",
    stopOpacity: 0.34
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "evenodd",
    d: "M16,8c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8C12.4,0,16,3.6,16,8z",
    clipRule: "evenodd"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: -2.644,
    cy: 20.358,
    r: 0.101,
    gradientTransform: "matrix(14.5998 6.5456 5.063 -11.2928 -62.74 255.526)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f28a2d",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28a2d",
    stopOpacity: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillRule: "evenodd",
    d: "M16,8c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8C12.4,0,16,3.6,16,8z",
    clipRule: "evenodd"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: -2.227,
    cy: 19.541,
    r: 0.283,
    gradientTransform: "matrix(12.5663 -9.904 -3.6032 -4.5717 110.263 79.053)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f28a2d",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28a2d",
    stopOpacity: 0
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "evenodd",
    d: "M16,8c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8C12.4,0,16,3.6,16,8z",
    clipRule: "evenodd"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: -2.531,
    cy: 19.776,
    r: 0.107,
    gradientTransform: "matrix(15.7394 -2.8762 -.572 -3.1299 56.242 56.647)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d45f00",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28a2d",
    stopOpacity: 0
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillRule: "evenodd",
    d: "M16,8c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8C12.4,0,16,3.6,16,8z",
    clipRule: "evenodd"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: -2.098,
    cy: 20.131,
    r: 0.106,
    gradientTransform: "matrix(15.6768 3.1995 .6363 -3.1176 30.972 71.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d45f00",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d45f00",
    stopOpacity: 0
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillRule: "evenodd",
    d: "M16,8c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8C12.4,0,16,3.6,16,8z",
    clipRule: "evenodd"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -1.619,
    x2: -1.619,
    y1: 18.2,
    y2: 16.681,
    gradientTransform: "matrix(3.4035 0 0 -.9374 13.51 22.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#482314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a4111"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillRule: "evenodd",
    d: "M9.7,5.9c-0.1-0.3-3.3-0.3-3.4,0C6.2,6.2,6.9,6.6,8,6.6C9.1,6.6,9.8,6.2,9.7,5.9z",
    clipRule: "evenodd"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: -3.9,
    cy: 18.924,
    r: 0.872,
    gradientTransform: "matrix(0 -2.1326 -2.1327 0 45.352 -4.046)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b446b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#202340"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    fillRule: "evenodd",
    d: "M6,4.1C6,4.8,5.6,5,5,5.1c-0.6,0.1-1.1-0.2-1.1-1c0-0.6,0.3-1.4,1.1-1.4C5.7,2.7,6,3.5,6,4.1z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e506a",
    fillRule: "evenodd",
    d: "M4.9,3.1C5,3.2,5,3.5,4.8,3.6c-0.1,0.1-0.3,0.2-0.4,0s-0.1-0.3,0-0.5C4.6,3,4.8,3,4.9,3.1L4.9,3.1z",
    clipRule: "evenodd"
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: -3.914,
    cy: 18.924,
    r: 0.872,
    gradientTransform: "matrix(0 -2.1326 -2.1327 0 51.366 -4.077)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b446b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#202340"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillRule: "evenodd",
    d: "M10,4.1c0,0.7,0.4,0.9,1.1,1c0.6,0.1,1.1-0.2,1.1-1c0-0.6-0.3-1.4-1.1-1.4C10.3,2.7,10,3.5,10,4.1z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e506a",
    fillRule: "evenodd",
    d: "M11,3.1c0.1,0.1,0,0.3-0.1,0.5c-0.1,0.1-0.3,0.1-0.4,0s0-0.3,0.1-0.5C10.8,2.9,10.9,2.9,11,3.1z",
    clipRule: "evenodd"
  })), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: -5.202,
    cy: 20.231,
    r: 0.298,
    gradientTransform: "matrix(-.339 -1.3177 -6.1081 1.5713 126.811 -36.933)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e38200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd6700"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    fillRule: "evenodd",
    d: "M3.4,2.1c-0.2,0.2,0,0.5,0.3,0.4C4.3,2.2,5.5,1.9,6.5,2c0.3,0,0.4,0,0.3-0.4C6.8,1.3,6.4,1.1,5.6,1.2 C4.4,1.3,3.6,1.9,3.4,2.1z",
    clipRule: "evenodd"
  })), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: -4.247,
    cy: 20.267,
    r: 0.314,
    gradientTransform: "matrix(.2577 -1.3359 -7.9278 -1.5293 172.702 26.852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e38200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd6700"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    fillRule: "evenodd",
    d: "M10.4,1.2C9.6,1.1,9.2,1.3,9.2,1.6C9.1,2,9.2,2,9.5,2c1.1-0.1,2.3,0.2,2.8,0.5c0.4,0.2,0.5-0.2,0.3-0.4 C12.4,1.9,11.6,1.3,10.4,1.2z",
    clipRule: "evenodd"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -2.17,
    x2: -2.407,
    y1: 20.358,
    y2: 19.647,
    gradientTransform: "matrix(9.7496 0 0 -9.079 27.91 194.578)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f34462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc0820"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    fillRule: "evenodd",
    d: "M9.7,8.5C7.6,7.9,6.9,9.3,6.9,9.3S7.1,7.7,5,7C3,6.4,1.8,8.3,1.7,9.4c-0.2,2.5,2,5.3,2.8,6.3 C4.6,16,4.9,16,5.2,16c1.2-0.3,4.6-1.4,5.9-3.6C11.6,11.3,11.7,9.1,9.7,8.5z",
    clipRule: "evenodd"
  })), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: -1.839,
    cy: 20.363,
    r: 0.29,
    gradientTransform: "matrix(8.51 3.1636 3.1637 -8.51 -39.932 190.042)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7091",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe6d8e",
    stopOpacity: 0
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    fillRule: "evenodd",
    d: "M9.7,8.5C7.6,7.9,6.9,9.3,6.9,9.3S7.1,7.7,5,7C3,6.4,1.8,8.3,1.7,9.4c-0.2,2.5,2,5.3,2.8,6.3 C4.6,16,4.9,16,5.2,16c1.2-0.3,4.6-1.4,5.9-3.6C11.6,11.3,11.7,9.1,9.7,8.5z",
    clipRule: "evenodd"
  })), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: -2.308,
    cy: 20.509,
    r: 0.29,
    gradientTransform: "matrix(8.51 3.1636 3.1637 -8.51 -40.975 191.442)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7091",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe6d8e",
    stopOpacity: 0
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    fillRule: "evenodd",
    d: "M9.7,8.5C7.6,7.9,6.9,9.3,6.9,9.3S7.1,7.7,5,7C3,6.4,1.8,8.3,1.7,9.4c-0.2,2.5,2,5.3,2.8,6.3 C4.6,16,4.9,16,5.2,16c1.2-0.3,4.6-1.4,5.9-3.6C11.6,11.3,11.7,9.1,9.7,8.5z",
    clipRule: "evenodd"
  })), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: -2.505,
    cy: 20.75,
    r: 0.249,
    gradientTransform: "matrix(-1.8271 8.8932 12.246 2.5158 -254.697 -18.163)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c0600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c0600",
    stopOpacity: 0
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    fillRule: "evenodd",
    d: "M9.7,8.5C7.6,7.9,6.9,9.3,6.9,9.3S7.1,7.7,5,7C3,6.4,1.8,8.3,1.7,9.4c-0.2,2.5,2,5.3,2.8,6.3 C4.6,16,4.9,16,5.2,16c1.2-0.3,4.6-1.4,5.9-3.6C11.6,11.3,11.7,9.1,9.7,8.5z",
    clipRule: "evenodd"
  })), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: -1.547,
    cy: 20.349,
    r: 0.15,
    gradientTransform: "matrix(7.812 4.6261 5.8059 -9.8043 -94.645 218.657)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c0600",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c0600",
    stopOpacity: 0
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    fillRule: "evenodd",
    d: "M9.7,8.5C7.6,7.9,6.9,9.3,6.9,9.3S7.1,7.7,5,7C3,6.4,1.8,8.3,1.7,9.4c-0.2,2.5,2,5.3,2.8,6.3 C4.6,16,4.9,16,5.2,16c1.2-0.3,4.6-1.4,5.9-3.6C11.6,11.3,11.7,9.1,9.7,8.5z",
    clipRule: "evenodd"
  })), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: -2.763,
    cy: 20.429,
    r: 0.13,
    gradientTransform: "matrix(8.5228 -3.1289 -4.0321 -10.983 107.977 224.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c0600",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c0600",
    stopOpacity: 0
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    fillRule: "evenodd",
    d: "M9.7,8.5C7.6,7.9,6.9,9.3,6.9,9.3S7.1,7.7,5,7C3,6.4,1.8,8.3,1.7,9.4c-0.2,2.5,2,5.3,2.8,6.3 C4.6,16,4.9,16,5.2,16c1.2-0.3,4.6-1.4,5.9-3.6C11.6,11.3,11.7,9.1,9.7,8.5z",
    clipRule: "evenodd"
  })), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: -1.795,
    cy: 20.148,
    r: 0.175,
    gradientTransform: "matrix(7.5205 5.0863 5.5088 -8.1451 -88.557 187.152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c0600",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c0600",
    stopOpacity: 0
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    fillRule: "evenodd",
    d: "M9.7,8.5C7.6,7.9,6.9,9.3,6.9,9.3S7.1,7.7,5,7C3,6.4,1.8,8.3,1.7,9.4c-0.2,2.5,2,5.3,2.8,6.3 C4.6,16,4.9,16,5.2,16c1.2-0.3,4.6-1.4,5.9-3.6C11.6,11.3,11.7,9.1,9.7,8.5z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "s",
    width: 6.9,
    height: 5.4,
    x: -0.2,
    y: 7.2,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "u",
    width: 6.9,
    height: 5.4,
    x: -0.2,
    y: 7.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16,8c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8C12.4,0,16,3.6,16,8z",
    clipRule: "evenodd",
    filter: "url(#s)"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: -2.204,
    cy: 20.844,
    r: 1.226,
    gradientTransform: "matrix(4.3582 3.2271 3.227 -4.3582 -57.739 105.424)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eda83a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdc5e"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    fillRule: "evenodd",
    d: "M1.3,7.7C0.8,7.2-0.1,6.9-0.2,8.1c-0.1,0.9,0.3,2.5,1.4,3.4c2.8,2.2,5.3,1,5.4-0.6c0.1-1.2-1.4-1.1-1.8-1.1 c0,0,0,0,0-0.1c0.1-0.1,0.3-0.2,0.4-0.3c0.4-0.3,0.2-0.8-0.3-0.7c-0.1,0-1.3,0.4-2.1,0.1C2,8.5,1.9,8.2,1.3,7.7z",
    clipRule: "evenodd",
    mask: "url(#u)"
  })), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 15.654,
    cy: 7.737,
    r: 8.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eda83a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdc5e"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M14.3,7.8c0.3-0.6,0.8-0.4,1.1-0.3c0.4,0.1,0.7,0.4,0.7,1c0,1.5-0.2,2.9-1.5,4.3 c-2.3,2.6-6.2,2.2-6.6,0.6C7.7,12.2,9.1,12,9.6,12c0,0,0-0.1,0-0.1c-0.2-0.1-0.3-0.2-0.5-0.3c-0.4-0.3-0.3-0.9,0.2-0.8 c0.6,0.1,1.4,0.3,2,0.2C13.2,10.8,13.5,9.3,14.3,7.8L14.3,7.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCare);
export default __webpack_public_path__ + "static/media/care.02502e7c877338faedd3e808e0059abb.svg";
export { ForwardRef as ReactComponent };